import { render, staticRenderFns } from "./com.vue?vue&type=template&id=8cda5248"
import script from "./com.vue?vue&type=script&lang=js"
export * from "./com.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports